<template>
  <div>
    <el-button-group>
      <el-button type="primary" size="mini" @click="openExcelTemplateList">
        <i class="fa fa-arrow-down"></i>
        导出
      </el-button>
    </el-button-group>
    <p></p>
    <el-table
      ref="table"
      :data="tableData"
      stripe
      size="small"
      style="width: 100%"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <el-table-column
        prop="deImageUrl"
        :label="$l('products_table_head_image') || '图片'"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <img
            fit="cover"
            :src="
              scope.row.defaultImageUrl
                ? scope.row.defaultImageUrl
                : '/image/static/img/nopic.jpg'
            "
            style="width: 90px;height: 60px;"
          />
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        prop="sampleStyleNo"
        :label="$l('products_table_head_sampleNo') || '样品款号'"
        min-width="150"
      >
      </el-table-column>
      <el-table-column
        align="left"
        prop="sampleName"
        :label="$l('products_table_head_sampleName') || '样品名称'"
        min-width="300"
      >
        <template slot-scope="scope">
          <div>
            {{ $l('products_table_head_chineseName') || '中文名称' }}：{{
              scope.row.sampleName
            }}
          </div>
          <div>
            {{ $l('products_table_head_englishName') || '英文名称' }}：{{
              scope.row.sampleNameEn
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        prop="supCostPrice"
        :label="$l('products_table_head_offer') || '报价'"
        min-width="150"
      >
        <template slot-scope="scope">
          <div>
            {{ $l('products_table_head_factoryQuotation') || '工厂报价' }}：{{
              scope.row.supCostPrice
            }}
          </div>
          <div>
            {{ $l('products_table_head_ABSquotation') || 'ABS报价' }}：{{
              scope.row.estimateCostPrice
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        prop="sampleSpec"
        :label="$l('products_table_head_specifications') || '规格'"
        min-width="150"
      >
        <template slot-scope="scope">
          <div>Size：{{ scope.row.sampleSpec }}</div>
          <div>Weight：{{ scope.row.sampleWeight }}</div>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        prop="sampleSalesSeason"
        :label="$l('products_table_head_salesSeason') || '销售季节'"
        min-width="130"
      >
      </el-table-column>
      <el-table-column
        align="left"
        prop="costMainType"
        :label="$l('products_table_head_mainCostType') || '主成本类型'"
        min-width="130"
      >
      </el-table-column>
      <el-table-column
        align="left"
        prop="componentEn"
        :label="
          $l('products_table_head_compositionOfFinishedProduct') || '成品成分'
        "
        min-width="300"
      >
        <template slot-scope="scope">
          <div>
            {{ $l('products_table_head_chinese') || '中文' }}：{{
              scope.row.componentZh
            }}
          </div>
          <div>
            {{ $l('products_table_head_english') || '英文' }}：{{
              scope.row.componentEn
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        prop="fringeSize"
        :label="$l('products_table_head_tasselSize') || '流苏尺寸'"
        min-width="130"
      >
      </el-table-column>
      <el-table-column
        align="left"
        prop="sampleMemo"
        :label="$l('products_table_head_remarks') || '备注说明'"
        min-width="300"
      >
      </el-table-column>
      <el-table-column
        align="left"
        prop="sortOrder"
        :label="$l('products_table_head_sort') || '排序'"
        min-width="150"
      >
      </el-table-column>
      <el-table-column
        align="left"
        prop="sampleSource"
        :label="$l('products_table_head_sampleSource') || '样品来源'"
        min-width="200"
      >
      </el-table-column>
      <el-table-column
        align="left"
        prop="productTypeName"
        :label="$l('products_table_head_productType') || '产品类型'"
        min-width="150"
      >
      </el-table-column>
      <el-table-column
        :label="$l('table_head_operation') || '操作'"
        width="80"
        fixed="right"
        v-if="!isViewDisabled"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            @click="fromLoad('edit', scope.row)"
            type="text"
            size="small"
            >{{ $l('products_table_head_edit') || '修改' }}</el-button
          >
        </template>
      </el-table-column>
      <div slot="empty">
        <div class="mt-60">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </div>
    </el-table>
    <el-dialog
      ref="itemForm"
      :title="formOption.title"
      :visible.sync="formOption.itemDialogVisible"
      :before-close="itemCancel"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="itemForm" :rules="rules">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :lg="12">
            <el-form-item
              :label="$l('products_table_head_sampleName') || '样品中文名称'"
              prop="sampleName"
            >
              <el-input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 20 }"
                v-model="itemForm.sampleName"
                maxlength="500"
                clearable
                size="mini"
                :placeholder="$l('tips_pleaseEnter') || '请输入..'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="12">
            <el-form-item
              :label="$l('products_table_head_sampleNameEn') || '样品英文名称'"
              prop="sampleNameEn"
            >
              <el-input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 20 }"
                v-model="itemForm.sampleNameEn"
                maxlength="500"
                clearable
                size="mini"
                :placeholder="$l('tips_pleaseEnter') || '请输入..'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="12">
            <el-form-item
              :label="$l('products_table_factoryQuotation') || '工厂报价'"
              prop="supCostPrice"
            >
              <el-input
                v-model="itemForm.supCostPrice"
                clearable
                size="small"
                maxlength="18"
                :placeholder="$l('tips_pleaseEnter') || '请输入..'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="12">
            <el-form-item
              :label="$l('products_table_ABSquotation') || 'ABS报价'"
              prop="estimateCostPrice"
            >
              <el-input
                v-model="itemForm.estimateCostPrice"
                clearable
                size="small"
                maxlength="18"
                :placeholder="$l('tips_pleaseEnter') || '请输入..'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="12">
            <el-form-item
              :label="$l('products_table_head_specifications') || '产品规格'"
              prop="sampleSpec"
            >
              <el-input
                v-model="itemForm.sampleSpec"
                clearable
                size="small"
                :placeholder="$l('tips_pleaseEnter') || '请输入..'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="12">
            <el-form-item
              :label="$l('products_table_WeightPerGram') || '产品克重'"
              prop="sampleWeight"
            >
              <el-input
                v-model="itemForm.sampleWeight"
                clearable
                size="small"
                :placeholder="$l('tips_pleaseEnter') || '请输入..'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="12">
            <el-form-item
              :label="$l('products_table_head_salesSeason') || '销售季节'"
              prop="sampleSalesSeason"
            >
              <el-input
                v-model="itemForm.sampleSalesSeason"
                clearable
                size="small"
                :placeholder="$l('tips_pleaseEnter') || '请输入..'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="12">
            <el-form-item
              :label="$l('products_table_MainCostType') || '主成本类型'"
              prop="costMainType"
            >
              <el-radio-group
                style="width: 100%"
                size="small"
                v-model="itemForm.costMainType"
              >
                <el-radio label="ABS">ABS</el-radio>
                <el-radio label="Factory">Factory</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="12">
            <el-form-item
              :label="
                $l('products_table_compositionOfFinishedProductInChine') ||
                  '成品成分中文'
              "
              prop="componentZh"
            >
              <el-input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 20 }"
                v-model="itemForm.componentZh"
                maxlength="500"
                clearable
                size="mini"
                :placeholder="$l('tips_pleaseEnter') || '请输入..'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="12">
            <el-form-item
              :label="
                $l('products_table_compositionOfFinishedProduct') ||
                  '成品成分英文'
              "
              prop="componentEn"
            >
              <el-input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 20 }"
                v-model="itemForm.componentEn"
                maxlength="500"
                clearable
                size="mini"
                :placeholder="$l('tips_pleaseEnter') || '请输入..'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="12">
            <el-form-item
              :label="$l('products_table_head_tasselSize') || '流苏尺寸'"
              prop="fringeSize"
            >
              <el-input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 20 }"
                v-model="itemForm.fringeSize"
                maxlength="500"
                clearable
                size="mini"
                :placeholder="$l('tips_pleaseEnter') || '请输入..'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="12">
            <el-form-item
              :label="$l('products_table_head_remarks') || '备注说明'"
              prop="sampleMemo"
            >
              <el-input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 20 }"
                v-model="itemForm.sampleMemo"
                maxlength="500"
                clearable
                size="mini"
                :placeholder="$l('tips_pleaseEnter') || '请输入..'"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="itemCancel" size="small">
          {{ $l('INDEX.btn_cancel') || '取 消' }}
        </el-button>
        <el-button
          type="primary"
          @click="itemSave"
          size="small"
          v-show="formOption.itemDialogSaveBtnVisible"
        >
          {{ $l('INDEX.btn_save') || '保 存' }}
        </el-button>
      </div>
    </el-dialog>

    <!-- Excel导出模板 -->
    <el-dialog
      ref="formDialog"
      :title="$l('tips_export_title') || '选择导出模板'"
      :visible.sync="excelTemplateVisible"
      :close-on-click-modal="false"
      width="950px"
    >
      <excel-template-list ref="excelTemplate" @export="exportExcel"></excel-template-list>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'item',
  props: {
    params: {
      default: null,
      type: Object,
    },
    autoLoad: {
      default: false,
      type: Boolean,
    },
    isViewDisabled: {
      default: null,
      type: Boolean,
    },
  },
  components: {
    ExcelTemplateList: () => import("@/views/digital/personal/myQuotation/components/main/components/list"),
  },
  data() {
    let reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/ // 验证金额
    let checkSupCostPrice = (rule, value, callback) => {
      if (value) {
        if (!reg.test(value)) {
          callback(new Error('工厂报价应是数字且保留1到2位小数'))
        }
        callback()
      }
    }
    let checkEstimateCostPrice = (rule, value, callback) => {
      if (value) {
        if (!reg.test(value)) {
          callback(new Error('ABS报价应是数字且保留1到2位小数'))
        }
        callback()
      }
    }
    return {
      excelTemplateVisible: false,
      isBusy: false,
      tableData: [],
      itemForm: {
        quotationItemCode: '',
        estimateCostPrice: '',
        supCostPrice: '',
        sampleSalesSeason: '',
        costMainType: '',
        sampleName: '',
        sampleSpec: '',
        sampleWeight: '',
        sampleNameEn: '',
        componentZh: '',
        componentEn: '',
        fringeSize: '',
        sampleMemo: '',
      },
      // 表单设置
      formOption: {
        title: '',
        itemDialogVisible: false,
        itemDialogSaveBtnVisible: true,
      },
      tableDataFields: [
        {
          key: 'defaultImageUrl',
          label: this.$l('products_table_head_image') || '图片',
          thClass: 'text-center',
          tdClass: 'align-middle text-center ',
        },
        {
          key: 'sampleStyleNo',
          label: this.$l('products_table_head_sampleNo') || '样品款号',
          thClass: 'text-center',
          tdClass: 'align-middle text-center ',
        },
        {
          key: 'sampleName',
          label: this.$l('products_table_head_sampleName') || '样品名称',
          thClass: 'text-center',
          tdClass: 'align-middle text-center ',
        },
        {
          key: 'supCostPrice',
          label: this.$l('products_table_head_offer') || '报价',
          thClass: 'text-center',
          tdClass: 'align-middle text-center ',
        },
        {
          key: 'sampleSpec',
          label: this.$l('products_table_head_specifications') || '规格',
          thClass: 'text-center',
          tdClass: 'align-middle text-center ',
        },
        {
          key: 'sampleSalesSeason',
          label: this.$l('products_table_head_salesSeason') || '销售季节',
          thClass: 'text-center',
          tdClass: 'align-middle text-center ',
        },
        {
          key: 'costMainType',
          label: this.$l('products_table_head_mainCostType') || '主成本类型',
          thClass: 'text-center',
          tdClass: 'align-middle text-center ',
        },
        {
          key: 'componentEn',
          label:
            this.$l('products_table_head_compositionOfFinishedProduct') ||
            '成品成分',
          thClass: 'text-center',
          tdClass: 'align-middle text-center ',
        },
        {
          key: 'fringeSize',
          label: this.$l('products_table_head_tasselSize') || '流苏尺寸',
          thClass: 'text-center',
          tdClass: 'align-middle text-center ',
        },
        {
          key: 'sampleMemo',
          label: this.$l('products_table_head_remarks') || '备注说明',
          thClass: 'text-center',
          tdClass: 'align-middle text-center ',
        },
        {
          key: 'sortOrder',
          label: this.$l('products_table_head_sort') || '排序',
          thClass: 'text-center',
          tdClass: 'align-middle text-center ',
        },
        {
          key: 'sampleSource',
          label: this.$l('products_table_head_sampleSource') || '样品来源',
          thClass: 'text-center',
          tdClass: 'align-middle text-center ',
        },
        {
          key: 'productTypeName',
          label: this.$l('products_table_head_productType') || '产品类型',
          thClass: 'text-center',
          tdClass: 'align-middle text-center ',
        },
        {
          key: 'operation',
          label: this.$l('table_head_operation') || '操作',
          thClass: 'text-center',
          tdClass: 'align-middle text-center ',
        },
      ],
      rules: {
        sampleName: [
          {
            required: true,
            message: this.$l('tips_input_sampleName') || '请输入样品中文名称',
            trigger: 'blur',
          },
        ],
        sampleNameEn: [
          {
            required: true,
            message: this.$l('tips_input_sampleNameEN') || '请输入样品英文名称',
            trigger: 'blur',
          },
        ],
        supCostPrice: [
          { required: false, validator: checkSupCostPrice, trigger: 'blur' },
        ],
        estimateCostPrice: [
          {
            required: false,
            validator: checkEstimateCostPrice,
            trigger: 'blur',
          },
        ],
      },
    }
  },
  watch: {
    params: {
      handler(val) {
        if (this.autoLoad) {
          this.load()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 加载表单
    load() {
      // 加载表格数据
      this.isBusy = true
      this.$api.myQuotationItemListApi(this.params).then((res) => {
        this.isBusy = false
        this.tableData = res.body.data
      })
    },
    fromLoad(ref, val = '') {
      if (ref === 'edit') {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
        this.itemForm = { ...val }
        this.formOption.itemDialogVisible = true
      }
    },
    itemCancel() {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
      this.formOption.itemDialogVisible = false
    },
    itemSave() {
      this.$api.myQuotationItemSaveApi(this.itemForm).then((res) => {
        this.$message({
          showClose: true,
          message: this.$l('tips_save_ok') || '保存成功',
          type: 'success',
        })
        this.formOption.itemDialogVisible = false
        this.load()
      })
    },
    openExcelTemplateList() {
      // 显示模板列表弹框
      this.excelTemplateVisible = true;
      this.$nextTick(()=>{
        this.$refs.excelTemplate.loadData();
      })
    },
    exportExcel(template) {
      let param = {
        quotationCode: this.params.quotationCode,
        templateCode: template.templateCode,
      };

      var quotationNo = this.params.quotationNo;
      var custName = this.params.custName;
      var url = "/export/quotaionExport/execExport";
      var suffix = ".xlsx";
      if (template.templateFileDesc.indexOf("PPT") !== -1) {
        url = "/export/quotationPptExport/execExport";
        suffix = ".pptx";
      }
      this.$api.exportExcel(url, param).then((res) => {
        const content = res;
        var responseType = res.type;
        const blob = new Blob([content], {
          type: responseType,
        });
        if (
          res.type !== "application/vnd.ms-excel" &&
          res.type !== "application/octet-stream" &&
          res.type !== "text/xml"
        ) {
          var reader = new FileReader();
          reader.readAsText(blob, "utf-8");
          var _this = this;
          reader.onload = function (e) {
            var resultJson = JSON.parse(reader.result);
            _this.$message.error(resultJson.msg);
          };
          return;
        }
        var fileName = custName + quotationNo + suffix;
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
  },
}
</script>
